// extracted by mini-css-extract-plugin
export default {"iconButtons":"styles_iconButtons__xJBKE"};